import { useTranslation } from "react-i18next";

export default function InfoSections() {
  const { t } = useTranslation();

  return (
    <div className="space-y-0">
      {/* Review */}
      <section className="py-14 md:py-20 bg-primary-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-12">
            <div className="md:w-1/2">
              <div className="w-12 h-12 rounded-xl bg-primary-100 text-primary-700 flex items-center justify-center mb-4">
                <i className="ri-star-smile-line text-2xl" />
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">{t("reviewSection.h2")}</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{t("reviewSection.copy")}</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors">{t("reviewSection.cta")}<i className="ri-arrow-right-line" /></a>
            </div>
            <div className="md:w-1/2">
              <div className="rounded-xl overflow-hidden border border-background-200/60 shadow-sm">
                <img src="https://readdy.ai/api/search-image?query=Minimalist%20product%20review%20desk%20setup%20with%20notebook%20and%20laptop%20warm%20natural%20light%20editorial%20clean%20aesthetic&width=800&height=500&seq=info-review-01&orientation=landscape" alt="Review" className="w-full h-48 md:h-64 object-cover object-top" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shipping */}
      <section className="py-14 md:py-20 bg-accent-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-12">
            <div className="md:w-1/2">
              <div className="w-12 h-12 rounded-xl bg-accent-100 text-accent-700 flex items-center justify-center mb-4">
                <i className="ri-truck-line text-2xl" />
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">{t("shippingSection.h2")}</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{t("shippingSection.copy")}</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors">{t("shippingSection.cta")}<i className="ri-arrow-right-line" /></a>
            </div>
            <div className="md:w-1/2">
              <div className="rounded-xl overflow-hidden border border-background-200/60 shadow-sm">
                <img src="https://readdy.ai/api/search-image?query=Shipping%20packages%20and%20boxes%20on%20wooden%20table%20warm%20natural%20light%20minimal%20clean%20aesthetic%20editorial&width=800&height=500&seq=info-shipping-01&orientation=landscape" alt="Shipping" className="w-full h-48 md:h-64 object-cover object-top" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Coupon */}
      <section className="py-14 md:py-20 bg-secondary-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-12">
            <div className="md:w-1/2">
              <div className="w-12 h-12 rounded-xl bg-secondary-100 text-secondary-700 flex items-center justify-center mb-4">
                <i className="ri-coupon-3-line text-2xl" />
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">{t("couponSection.h2")}</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{t("couponSection.copy")}</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors">{t("couponSection.cta")}<i className="ri-arrow-right-line" /></a>
            </div>
            <div className="md:w-1/2">
              <div className="rounded-xl overflow-hidden border border-background-200/60 shadow-sm">
                <img src="https://readdy.ai/api/search-image?query=Minimalist%20coupon%20tags%20and%20discount%20labels%20on%20warm%20beige%20background%20soft%20light%20editorial%20clean&width=800&height=500&seq=info-coupon-01&orientation=landscape" alt="Coupon" className="w-full h-48 md:h-64 object-cover object-top" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Warehouse */}
      <section className="py-14 md:py-20 bg-primary-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-12">
            <div className="md:w-1/2">
              <div className="w-12 h-12 rounded-xl bg-primary-100 text-primary-700 flex items-center justify-center mb-4">
                <i className="ri-building-2-line text-2xl" />
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">{t("warehouseSection.h2")}</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{t("warehouseSection.copy")}</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors">{t("warehouseSection.cta")}<i className="ri-arrow-right-line" /></a>
            </div>
            <div className="md:w-1/2">
              <div className="rounded-xl overflow-hidden border border-background-200/60 shadow-sm">
                <img src="https://readdy.ai/api/search-image?query=Modern%20warehouse%20interior%20with%20organized%20shelves%20warm%20lighting%20minimal%20clean%20aesthetic%20editorial&width=800&height=500&seq=info-warehouse-01&orientation=landscape" alt="Warehouse" className="w-full h-48 md:h-64 object-cover object-top" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Safety */}
      <section className="py-14 md:py-20 bg-accent-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-12">
            <div className="md:w-1/2">
              <div className="w-12 h-12 rounded-xl bg-accent-100 text-accent-700 flex items-center justify-center mb-4">
                <i className="ri-shield-star-line text-2xl" />
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">{t("safetySection.h2")}</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{t("safetySection.copy")}</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors">{t("safetySection.cta")}<i className="ri-arrow-right-line" /></a>
            </div>
            <div className="md:w-1/2">
              <div className="rounded-xl overflow-hidden border border-background-200/60 shadow-sm">
                <img src="https://readdy.ai/api/search-image?query=Security%20shield%20and%20padlock%20minimal%20illustration%20warm%20neutral%20tones%20clean%20aesthetic%20editorial&width=800&height=500&seq=info-safety-01&orientation=landscape" alt="Safety" className="w-full h-48 md:h-64 object-cover object-top" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}